import styled, { css } from 'styled-components';

export const NotificationWrapper = styled.div<{ $hasIndicator?: boolean }>`
  position: relative;

  ${({ $hasIndicator }) =>
    $hasIndicator &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: ${({ theme }) => theme.spacing(2)}px;
        right: ${({ theme }) => theme.spacing(3)}px;
        width: ${({ theme }) => theme.spacing(2)}px;
        height: ${({ theme }) => theme.spacing(2)}px;
        border-radius: ${({ theme }) => theme.spacing(2)}px;
        background-color: ${({ theme }) => theme.colors.primary[600]};
      }
    `}
`;
